<div class="logo-container">
  <image-loader-utils extraClasses="logo-register" url="logo" [shared]="false" imageFormat="png"></image-loader-utils>
</div>
<div class="login-desktop text">
  <form class="login-form" [formGroup]="loginDatas">
    <div class="login-item">
      <input placeholder="{{ 'user_name' | translate }}" type="text" formControlName="userName" class="login-input" />
    </div>
    <div class="login-item">
      <input placeholder="{{ 'password' | translate }}" type="password" formControlName="userPassword" class="login-input" />
    </div>
  </form>
  <div class="item-row" *ngIf="isError">
    <div class="error-message">
      {{ errorMessage }}
    </div>
  </div>

  <div class="item-row" *ngIf="isError">
    <div class="btn colored register-button login-dropdown-btn">
      <div class="contact-btn-text">
        {{ 'Contact' | translate }}
      </div>
    </div>
  </div>
  <div class="item-row" (click)="submitLoginData()">
    <div class="btn colored blue login-dropdown-btn">
      <div class="login-button-text">{{ 'Login' | translate }}</div>
    </div>
  </div>
</div>

<div class="login-mobile text">
  <div class="sidenav-header">
    <div class="left">{{ 'Login' | translate }}</div>
  </div>
  <form class="login-mobile-form" [formGroup]="loginDatas">
    <div class="login-item">
      <inputBase formControlName="userName" fPlaceholder="{{ 'user_name' | translate }}" fInputType="input_text"></inputBase>
    </div>
    <div class="login-item">
      <inputBase formControlName="userPassword" fPlaceholder="{{ 'password' | translate }}" fInputType="password" extraClass="loginPassword"></inputBase>
    </div>
  </form>
  <div class="login-container">
    <div class="login-row" *ngIf="isError">
      <div class="error-message">
        {{ errorMessage }}
      </div>
    </div>
    <div class="login-row" (click)="submitLoginData()">
      <div class="btn mobile colored register-button">
        <div class="btn-text mobile-text">
          {{ 'Login' | translate }}
        </div>
      </div>
    </div>
    <div class="login-row">
      <div class="checkbox">
        <input type="checkbox" />
      </div>
      <div class="check-label">{{ 'AutoLogin' | translate }}</div>
    </div>
    <div class="login-row" *ngIf="isError">
      <div class="btn mobile colored register-button">
        <div class="btn-text mobile-text">
          {{ 'Contact' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
